'use client';

function autoUpdate(scrollParents, fn) {
    scrollParents.forEach(function (container) {
        container.addEventListener('scroll', fn, { passive: true });
        container.addEventListener('resize', fn, { passive: true });
    });
    fn();
    return function () {
        scrollParents.forEach(function (container) {
            container.removeEventListener('scroll', fn);
            container.removeEventListener('resize', fn);
        });
    };
}

export { autoUpdate as default };
//# sourceMappingURL=autoUpdate.js.map
